import { useEffect, useRef } from 'react';

import { SendAnalitics } from '../lib/playdeck';

type PurchaseAttemptParams = {
  item: string;
  item_id: string;
  price: number;
  currency: string;
  user_properties?: Record<string, unknown>;
};

const usePurchaseAttempt = (params: PurchaseAttemptParams): void => {
  const infoWasSend = useRef(false);

  useEffect(() => {
    if (infoWasSend.current) return;
    infoWasSend.current = true;
    SendAnalitics.purchaseAttempt(params);
  }, []);
};

export { usePurchaseAttempt };
